const BAA_NUDGE_SESSION_KEY_PREFIX = "baa-nudge-shown:";

export function baaNudgeSessionKey(profileId: string, loginId?: string | null) {
    return `${BAA_NUDGE_SESSION_KEY_PREFIX}${profileId}:${
        loginId || "current"
    }`;
}

// AIDEV-NOTE: The one place the per-login key is derived; the BAA dialog and the
// banners' useLoginDismissal must agree on it. Null until profile and login are known.
export function loginDismissalKey(
    profileId: string | null | undefined,
    loginId: string | null | undefined,
    suffix?: string,
): string | null {
    if (!profileId || !loginId) return null;
    const key = baaNudgeSessionKey(profileId, loginId);
    return suffix ? `${key}:${suffix}` : key;
}

export function clearBaaNudgeSessionKeys() {
    if (typeof window === "undefined") return;
    for (let index = window.sessionStorage.length - 1; index >= 0; index--) {
        const key = window.sessionStorage.key(index);
        if (key?.startsWith(BAA_NUDGE_SESSION_KEY_PREFIX)) {
            window.sessionStorage.removeItem(key);
        }
    }
}
